<template>
  <a-card :bordered="false">
    <!-- 查询表单 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="12">
            <a-form-item label="更新主题:">
              <a-input v-model="query.updateTheme" placeholder="请输入更新主题" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="10" :sm="12">
            <a-form-item label="更新时间:">
              <a-range-picker
                v-model="dateRange"
                @change="onDateRangeChange"
                format="YYYY-MM-DD"
                :placeholder="['开始日期', '结束日期']"
              />
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="queryList">查询</a-button>
              <a-button style="margin-left: 8px" @click="resetList">重置</a-button>
              <a-button type="primary" style="margin-left: 8px" @click="handleAdd">新增更新通知</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- 表格 -->
    <a-table
      rowKey="id"
      :data-source="list"
      :columns="columns"
      :loading="dataListLoading"
      :pagination="pagination"
      @change="pageChange"
      :bordered="true"
    >
      <template slot="newFeatures" slot-scope="text">
        <div v-if="text" v-html="text" style="max-height: 200px; overflow-y: auto;"></div>
        <span v-else>-</span>
      </template>
      <template slot="systemTuning" slot-scope="text">
        <div v-if="text" v-html="text" style="max-height: 200px; overflow-y: auto;"></div>
        <span v-else>-</span>
      </template>
      <template slot="issueFixing" slot-scope="text">
        <div v-if="text" v-html="text" style="max-height: 200px; overflow-y: auto;"></div>
        <span v-else>-</span>
      </template>
      <template slot="documentation" slot-scope="text">
        <div v-if="text" style="word-break: break-all;">
          <a :href="text" target="_blank" style="color: #1890ff">{{ text }}</a>
        </div>
        <span v-else>-</span>
      </template>
      <template slot="pushRole" slot-scope="text, record">
        <template v-if="record.tenantList && record.tenantList.length > 0">
          <a 
            v-for="(tenant, index) in record.tenantList" 
            :key="tenant.tenantId || index"
            @click="handleViewTenantDetails(tenant)"
            style="color: #1890ff; cursor: pointer; "
          >
            {{ tenant.realName || tenant.tenantName || tenant }}、
          </a>
        </template>
        <span v-else>-</span>
      </template>
      <template slot="action" slot-scope="text, record">
        <a @click="handleEdit(record)" style="color: #1890ff; margin-right: 8px">编辑</a>
        <a-popconfirm title="确定要删除这条记录吗?" @confirm="handleDelete(record)" okText="确定" cancelText="取消">
          <a style="color: #ff4d4f">删除</a>
        </a-popconfirm>
      </template>
    </a-table>

    <!-- 新增/编辑弹窗 -->
    <a-modal
      :title="isUpdate ? '编辑更新通知' : '新增更新通知'"
      :width="1200"
      :visible="addOrUpdateVisible"
      @ok="handleSubmit"
      @cancel="handleCancel"
      :confirmLoading="confirmLoading"
      :maskClosable="false"
    >
      <a-form-model
        ref="addOrUpdateForm"
        :model="formData"
        :rules="rules"
        :label-col="{ span: 4 }"
        :wrapper-col="{ span: 20 }"
      >
        <a-form-model-item label="更新主题:" prop="updateTheme">
          <a-input v-model="formData.updateTheme" placeholder="请输入更新主题" />
        </a-form-model-item>
        <a-form-model-item label="*更新时间:" prop="versionTime">
          <a-date-picker
            v-model="formData.versionTime"
            format="YYYY-MM-DD"
            placeholder="选择日期"
            style="width: 100%"
          />
        </a-form-model-item>
        <a-form-model-item label="*更新内容:" required>
          <a-form-model-item label="新增功能:" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }" style="margin-bottom: 16px">
            <QuillEditor
              :value="formData.newFeatures"
              @change="handleNewFeaturesChange"
            />
          </a-form-model-item>
          <a-form-model-item label="系统优化:" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }" style="margin-bottom: 16px">
            <QuillEditor
              :value="formData.systemTuning"
              @change="handleSystemTuningChange"
            />
          </a-form-model-item>
          <a-form-model-item label="问题修复:" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
            <QuillEditor
              :value="formData.issueFixing"
              @change="handleIssueFixingChange"
            />
          </a-form-model-item>
        </a-form-model-item>
        <a-form-model-item label="更新说明文档:">
          <a-upload
            :file-list="fileList"
            :before-upload="beforeUpload"
            :remove="handleRemove"
            :accept="'.pdf,.doc,.docx'"
          >
            <a-button type="primary">
              <a-icon type="upload" />选择文件
            </a-button>
          </a-upload>
          <div v-if="!fileList.length" style="margin-top: 8px; color: #999">未选择任何文件</div>
          <div v-else style="margin-top: 8px">
            <a-icon type="file" /> {{ fileList[0].name }}
          </div>
        </a-form-model-item>
        <a-form-model-item label="*租户选择:" prop="tenantList">
          <a-select
            v-model="formData.tenantList"
            mode="multiple"
            placeholder="请选择租户"
            style="width: 100%"
            :filter-option="filterTenantOption"
            show-search
          >
            <a-select-option v-for="item in tenantList" :key="item.tenantId" :value="item.tenantId">
              {{ item.tenantName }}
            </a-select-option>
          </a-select>
          <div style="margin-top: 8px; color: #999; font-size: 12px">
            注:所选租户下的所有账号将收到该更新通知!
          </div>
        </a-form-model-item>
        </a-form-model>
    </a-modal>

    <!-- 租户详情弹窗 -->
    <a-modal
      title="推送用户详情"
      :width="700"
      :visible="tenantDetailsVisible"
      @cancel="handleCloseTenantDetails"
      :footer="null"
    >
      <div style="margin-bottom: 16px;">
        <a-input
          v-model="tenantSearchKeyword"
          placeholder="搜索用户名"
          allow-clear
          style="width: 300px;"
          @change="handleTenantSearch"
        >
          <a-icon slot="prefix" type="search" />
        </a-input>
      </div>
      <div class="tenant-details-table-wrapper">
        <a-table
          :columns="tenantDetailsColumns"
          :data-source="filteredTenantDetailsList"
          :pagination="false"
          :bordered="true"
          size="small"
          rowKey="id"
        >
          <template slot="accountType" slot-scope="text">
            {{ text === 'tenant' ? '租户账号' : '子账号' }}
          </template>
          <template slot="isShow" slot-scope="text">
            <a-tag :color="text === 1 || text === '1' ? 'green' : 'orange'">
              {{ text === 1 || text === '1' ? '已查看' : '未查看' }}
            </a-tag>
          </template>
        </a-table>
      </div>
    </a-modal>
  </a-card>
</template>

<script>
import mixinViewModule from '@/mixin/common'
import moment from 'moment'
import QuillEditor from '@/components/Editor/QuillEditor'

const columns = [
{
    title: '序号',
    dataIndex: 'sort',
    align: 'center',
    width: 80,
    customRender: (text, record, index) => index + 1,
  },
  {
    title: '更新主题',
    dataIndex: 'updateTheme',
    key: 'updateTheme',
    width: 150,
  },
  {
    title: '新增功能',
    dataIndex: 'newFeatures',
    key: 'newFeatures',
    scopedSlots: { customRender: 'newFeatures' },
    width: 200,
  },
  {
    title: '系统优化',
    dataIndex: 'systemTuning',
    key: 'systemTuning',
    scopedSlots: { customRender: 'systemTuning' },
    width: 200,
  },
  {
    title: '问题修复',
    dataIndex: 'issueFixing',
    key: 'issueFixing',
    scopedSlots: { customRender: 'issueFixing' },
    width: 200,
  },
  {
    title: '说明文档',
    dataIndex: 'documentation',
    key: 'documentation',
    scopedSlots: { customRender: 'documentation' },
    width: 200,
  },
  {
    title: '推送租户',
    dataIndex: 'pushRole',
    key: 'pushRole',
    scopedSlots: { customRender: 'pushRole' },
    width: 150,
  },
  {
    title: '更新时间',
    dataIndex: 'versionTime',
    key: 'versionTime',
    width: 120,
  },
  {
    title: '操作',
    dataIndex: 'action',
    key: 'action',
    width: 120, 
    scopedSlots: { customRender: 'action' },
  },
]

export default {
  mixins: [mixinViewModule],
  name: 'SysUpdateList',
  components: {
    QuillEditor
  },
  data() {
    return {
      needQuery: false, // 禁用mixin的自动查询，手动控制
      queryUrl: '/manager/sys_update_push/selectUpdatePush',
      deleteUrl: '/manager/sys_update_push/delectUpdatePush',
      addUrl: '/manager/sys_update_push/addUpdatePush', // 新增接口
      updateUrl: '/manager/sys_update_push/upUpdatePush', // 更新接口
      query: {
        updateTheme: '',
        startTime: '',
        endTime: '',
        pageNum: 1,
        pageSize: 10,
      },
      dateRange: [],
      columns,
      formData: {
        id: 0,
        updateTheme: '',
        versionTime: null,
        newFeatures: '',
        systemTuning: '',
        issueFixing: '',
        documentation: '',
        tenantList: [],
      },
      fileList: [],
      uploadFile: null,
      confirmLoading: false,
      rules: {
        updateTheme: [{ required: true, message: '请输入更新主题', trigger: 'blur' }],
        versionTime: [{ required: true, message: '请选择更新时间', trigger: 'change' }],
        tenantList: [{ required: true, type: 'array', min: 1, message: '请至少选择一个租户', trigger: 'change' }],
      },
      // 租户详情相关
      tenantDetailsVisible: false,
      tenantDetailsList: [],
      tenantSearchKeyword: '',
      selectedTenantName: '', // 当前选中的租户名称
      tenantDetailsColumns: [
        {
          title: '序号',
          dataIndex: 'sort',
          key: 'sort',
          width: 80,
          customRender: (text, record, index) => index + 1,
        },
        {
          title: '账号性质',
          dataIndex: 'accountType',
          key: 'accountType',
          width: 120,
          scopedSlots: { customRender: 'accountType' },
        },
        {
          title: '用户名',
          dataIndex: 'username',
          key: 'username',
          width: 200,
        },
        {
          title: '是否查看通知',
          dataIndex: 'isShow',
          key: 'isShow',
          width: 150,
          scopedSlots: { customRender: 'isShow' },
        },
      ],
    }
  },
  computed: {
    // 过滤后的租户详情列表
    filteredTenantDetailsList() {
      let list = this.tenantDetailsList
      
      // 如果有关键词，先按关键词过滤
      if (this.tenantSearchKeyword) {
        const keyword = this.tenantSearchKeyword.toLowerCase()
        list = list.filter(item => {
          const username = (item.username || '').toLowerCase()
          return username.includes(keyword)
        })
      }
      
      return list
    },
  },
  created() { 
    this.getAllTenant()
    // 延迟执行，确保mixin的created先完成
    this.$nextTick(() => {
      console.log('=== 准备执行queryList ===')
      this.queryList() // 页面加载时自动查询
    })
  },
 
  methods: {
    moment,
    // 日期范围变化
    onDateRangeChange(dates) {
      if (dates && dates.length === 2) {
        this.query.startTime = moment(dates[0]).format('YYYY-MM-DD')
        this.query.endTime = moment(dates[1]).format('YYYY-MM-DD')
      } else {
        this.query.startTime = ''
        this.query.endTime = ''
      }
    },
    // 查询列表
    queryList() {
      console.log('queryList方法被调用')
      const params = {
        updateTheme: this.query.updateTheme || '',
        startTime: this.query.startTime || '',
        endTime: this.query.endTime || '',
        pageNum: this.pagination.current,
        pageSize: this.pagination.pageSize,
      }
      console.log('查询参数:', params)
      console.log('查询URL:', this.queryUrl)
      this.dataListLoading = true
      this.$http
        .get(this.queryUrl, { params })
        .then((res) => {
          console.log('查询成功，返回结果:', res)
          this.dataListLoading = false
          
          // 拦截器已经处理过，这里res就是res.data
          if (res.code === 0 || res.code === 200) {
            const data = res.data || res || {}
            console.log('解析后的数据:', data)
            this.list = data.rows 
            this.pagination.total = data.total ? parseInt(data.total) : 0
            console.log('列表数据:', this.list)
            console.log('总数:', this.pagination.total)
          } else {
            console.log('查询失败，code不是0或200:', res.code, res.message)
            this.list = []
            this.pagination.total = 0
            this.$message.error(res.message || '查询失败')
          }
        })
        .catch((error) => {
          console.log('查询错误:', error)
          console.log('错误对象结构:', {
            response: error.response,
            data: error.data,
            message: error.message
          })
          this.dataListLoading = false
          
          // 拦截器reject时，error可能是包含data的响应对象（拦截器返回Promise.reject(res)）
          // 所以error.data就是res.data
          let resData = null
          if (error.data) {
            // 拦截器reject的情况
            resData = error.data
            console.log('拦截器reject的响应数据:', resData)
          } else if (error.response && error.response.data) {
            // HTTP错误的情况
            resData = error.response.data
            console.log('HTTP错误响应数据:', resData)
          }
          
          // 如果业务code是200，仍然处理数据
          if (resData && resData.code === 200) {
            const data = resData || {}
          console.log(1, resData );

            this.list = data.rows 
            this.pagination.total = data.total ? parseInt(data.total) : 0
            console.log('从catch中处理数据成功，列表:', this.list)
            console.log('总数:', this.pagination.total)
            return
          }
          
          // 如果是其他错误，显示错误信息
          const errorMsg = resData?.message || error.message || '查询失败'
          if (errorMsg !== '查询失败') {
            this.$message.error(errorMsg)
          }
        })
    },
    // 重置
    resetList() {
      this.query = {
        updateTheme: '',
        startTime: '',
        endTime: '',
        pageNum: 1,
        pageSize: 10,
      }
      this.dateRange = []
      this.pagination.current = 1
      this.queryList()
    },
    // 分页变化
    pageChange(pagination) {
      this.pagination.current = pagination.current
      this.pagination.pageSize = pagination.pageSize
      this.queryList()
    },
    // 新增
    handleAdd() {
      this.isUpdate = false
      this.addOrUpdateVisible = true
      this.formData = {
        id: 0,
        updateTheme: '',
        versionTime: null,
        newFeatures: '',
        systemTuning: '',
        issueFixing: '',
        documentation: '',
        tenantList: [],
      }
      this.fileList = []
      this.uploadFile = null
      this.$nextTick(() => {
        if (this.$refs.addOrUpdateForm) {
          this.$refs.addOrUpdateForm.clearValidate()
        }
      })
    },
    // 编辑
    handleEdit(record) {
      this.isUpdate = true
      this.currentId = record.id
      this.addOrUpdateVisible = true
      // 先重置表单数据
      this.formData = {
        id: 0,
        updateTheme: '',
        versionTime: null,
        newFeatures: '',
        systemTuning: '',
        issueFixing: '',
        documentation: '',
        tenantList: [],
      }
      this.fileList = []
      this.uploadFile = null
      
      // 使用 $nextTick 确保弹窗已经渲染后再设置数据
      this.$nextTick(() => {
        // 直接使用列表中的数据，不调用接口
        this.formData = {
          id: record.id || 0,
          updateTheme: record.updateTheme || '',
          versionTime: record.versionTime ? moment(record.versionTime) : null,
          newFeatures: record.newFeatures || '',
          systemTuning: record.systemTuning || '',
          issueFixing: record.issueFixing || '',
          documentation: record.documentation || '',
          tenantList: record.tenantList ? record.tenantList.map(t => (typeof t === 'object' ? t.tenantId : t)) : [],
        }
        
        if (record.documentation) {
          this.fileList = [
            {
              uid: '-1',
              name: this.getFileName(record.documentation),
              status: 'done',
              url: record.documentation,
            },
          ]
        }
        
        if (this.$refs.addOrUpdateForm) {
          this.$refs.addOrUpdateForm.clearValidate()
        }
      })
    },
    // 删除
    handleDelete(record) {
      this.$http
        .post(this.deleteUrl, { ids: [record.id] })
        .then((res) => {
          if (res.code === 0 || res.code === 200) {
            this.$message.success('删除成功')
            this.queryList()
          } else {
            this.$message.error(res.message || '删除失败')
          }
        })
        .catch(() => {})
    },
    // 提交
    handleSubmit() {
      this.$refs.addOrUpdateForm.validate((valid) => {
        if (valid) {
          // 先上传文件（如果有新文件）
          if (this.uploadFile) {
            this.uploadDocumentation()
          } else {
            this.submitForm()
          }
        }
      })
    },
    // 上传文档
    uploadDocumentation() {
      const formData = new FormData()
      formData.append('file', this.uploadFile)
      this.confirmLoading = true
      this.$http
        .post('/manager/file/resources/upload', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then((res) => {
          if (res.code === 0 && res.data && res.data.url) {
            this.formData.documentation = res.data.url
            this.submitForm()
          } else {
            this.confirmLoading = false
            this.$message.error(res.message || '文件上传失败')
          }
        })
        .catch(() => {
          this.confirmLoading = false
        })
    },
    // 提交表单
    submitForm() {
      const submitData = {
        updateTheme: this.formData.updateTheme,
        versionTime: this.formData.versionTime ? moment(this.formData.versionTime).format('YYYY-MM-DD') : '',
        newFeatures: this.formData.newFeatures || '',
        systemTuning: this.formData.systemTuning || '',
        issueFixing: this.formData.issueFixing || '',
        documentation: this.formData.documentation || '',
        tenantList: this.formData.tenantList || [],
      }
      // 只有更新时才传id
      if (this.isUpdate) {
        submitData.id = this.formData.id
      }
      this.confirmLoading = true
      // 根据 isUpdate 判断使用新增还是更新接口
      const url = this.isUpdate ? this.updateUrl : this.addUrl
      this.$http
        .post(url, submitData)
        .then((res) => {
          this.confirmLoading = false
          if (res.code === 0) {
            this.$message.success(this.isUpdate ? '更新成功' : '新增成功')
            this.addOrUpdateVisible = false
            this.queryList()
          } else {
            this.$message.error(res.message || '操作失败')
          }
        })
        .catch(() => {
          this.confirmLoading = false
        })
    },
    // 取消
    handleCancel() {
      this.addOrUpdateVisible = false
      this.formData = {
        id: 0,
        updateTheme: '',
        versionTime: null,
        newFeatures: '',
        systemTuning: '',
        issueFixing: '',
        documentation: '',
        tenantList: [],
      }
      this.fileList = []
      this.uploadFile = null
    },
    // 文件上传前
    beforeUpload(file) {
      this.uploadFile = file
      this.fileList = [
        {
          uid: file.uid,
          name: file.name,
          status: 'done',
        },
      ]
      return false // 阻止自动上传
    },
    // 移除文件
    handleRemove() {
      this.fileList = []
      this.uploadFile = null
      this.formData.documentation = ''
    },
    // 获取文件名
    getFileName(url) {
      if (!url) return ''
      const parts = url.split('/')
      return parts[parts.length - 1]
    },
    // 租户搜索过滤
    filterTenantOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    // 富文本编辑器变化处理
    handleNewFeaturesChange(html) {
      this.formData.newFeatures = html
    },
    handleSystemTuningChange(html) {
      this.formData.systemTuning = html
    },
    handleIssueFixingChange(html) {
      this.formData.issueFixing = html
    },
    // 查看租户详情
    handleViewTenantDetails(tenant) {
      // tenant 是单个租户对象
      const tenantName = tenant.realName || tenant.tenantName || ''
      this.selectedTenantName = tenantName
      
      // 创建租户账号数据（第一条）
      const tenantAccount = {
        username: tenant.username || '',
        isShow: tenant.isShow || '0',
        accountType: 'tenant', // 租户账号
        id: tenant.userId || tenant.id || Date.now(), // 使用userId作为id
      }
      
      // 获取子账号列表
      const subAccountList = tenant && tenant.sysUpdatePushTenantDetailsVos 
        ? (Array.isArray(tenant.sysUpdatePushTenantDetailsVos) ? tenant.sysUpdatePushTenantDetailsVos : [])
        : []
      
      // 处理子账号数据，账号性质为子账号
      const subAccounts = subAccountList.map(item => ({
        ...item,
        accountType: 'sub' // 子账号
      }))
      
      // 合并数据：租户账号在第一条，子账号在后面
      this.tenantDetailsList = [tenantAccount, ...subAccounts]
      
      this.tenantSearchKeyword = ''
      this.tenantDetailsVisible = true
    },
    // 关闭租户详情弹窗
    handleCloseTenantDetails() {
      this.tenantDetailsVisible = false
      this.tenantDetailsList = []
      this.tenantSearchKeyword = ''
      this.selectedTenantName = ''
    },
    // 租户搜索
    handleTenantSearch() {
      // 搜索逻辑在 computed 中处理，这里可以留空或添加其他逻辑
    },
  },
}
</script>

<style scoped>
.table-page-search-wrapper {
  margin-bottom: 16px;
}

.tenant-details-table-wrapper {
  max-height: 500px;
  overflow-y: auto;
}
</style>

<style>
/* 设置富文本编辑器高度 */
.ant-editor-quill .ql-container {
  min-height: 200px !important;
  height: 200px !important;
}

.ant-editor-quill .ql-editor {
  min-height: 200px !important;
}
</style>

